import React from 'react';

import { Button } from '@jimdo/ui';

import { TEMPLATES_PER_PAGE } from '../../modules/constants';
import TemplateListElement, {
  TemplateSelectionCallback,
} from '../templateListElement/templateListElement';
import { Template } from '../../modules/templateImages';

const MoveTo = require('moveto');

import './templateList.scss';

interface State {
  templates: Template[];
}

interface Props {
  templateImages: Template[];
  onSelect: TemplateSelectionCallback;
  onShowMore: (maxAmount: number) => void;
  buttonText: string;
  moreText: string;
  amountTemplates: number;
}

const SCROLL_DURATION = 1000;

export default class TemplateList extends React.PureComponent<Props, State> {
  private list: HTMLElement = null;
  private scroller: MoveTo = null;

  constructor(props: Props) {
    super(props);
    this.scroller = new MoveTo({
      duration: SCROLL_DURATION,
    });
    this.showMore = this.showMore.bind(this);
    this.state = {
      templates: props.templateImages.slice(0, TEMPLATES_PER_PAGE),
    };
  }

  public componentWillReceiveProps(nextProps: Props): void {
    const { amountTemplates, templateImages } = nextProps;
    if (this.state.templates.length === amountTemplates) {
      return;
    }
    const { height, top } = this.list.getBoundingClientRect();
    this.setState(
      {
        templates: templateImages.slice(0, amountTemplates),
      },
      () => this.scroller.move(height + top + window.scrollY)
    );
  }

  public render(): JSX.Element {
    const {
      templateImages,
      onSelect,
      buttonText,
      moreText,
      amountTemplates,
    } = this.props;
    const { templates } = this.state;
    const maxIndex = templateImages.length;

    const list = templates.map(({ subtype, desktopImage }: Template) => {
      return (
        <TemplateListElement
          buttonText={buttonText}
          image={desktopImage}
          onSelect={onSelect}
          key={subtype}
          subtype={subtype}
        />
      );
    });

    /* tslint:disable:react-this-binding-issue */
    return (
      <div className="templatelist-component">
        <ul
          ref={(elem: HTMLElement) => (this.list = elem)}
          className="templatelist-component__list"
        >
          {list}
        </ul>
        {amountTemplates < maxIndex ? (
          <Button
            className="templatelist-component__show-more-button"
            onClick={this.showMore}
            buttonStyle="secondary"
          >
            {moreText}
          </Button>
        ) : null}
      </div>
    );
  }

  private showMore(): void {
    const { templateImages, onShowMore } = this.props;
    onShowMore(templateImages.length);
  }
}
